import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import TeamForm from 'components/organisms/forms/TeamForm'

import { crudActionsMap } from 'utils/helpers'
import TeamEnrolledStudents from 'components/utilized/teams/TeamEnrolledStudents'
import { Box } from '@mui/material'

const TeamsCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.teams')} / ${t('common.' + action)}`} />
      <PageBody>
        <TeamForm action={action} id={id} viewOnly={viewOnly} />

        {id && <Box sx={{ marginTop: '50px' }}>
            <TeamEnrolledStudents action={action} id={id} viewOnly={viewOnly} />
          </Box> 
        }
      </PageBody>
    </>
  )
}
export default TeamsCrudPage
